/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Directive, Self} from '@angular/core';

import {AbstractControlDirective} from './abstract_control_directive';
import {ControlContainer} from './control_container';
import {NgControl} from './ng_control';
export class AbstractControlStatus {
private _cd: AbstractControlDirective;
/**
 * @param {?} cd
 */
constructor(cd: AbstractControlDirective) { this._cd = cd; }
/**
 * @return {?}
 */
get ngClassUntouched(): boolean { return this._cd.control ? this._cd.control.untouched : false; }
/**
 * @return {?}
 */
get ngClassTouched(): boolean { return this._cd.control ? this._cd.control.touched : false; }
/**
 * @return {?}
 */
get ngClassPristine(): boolean { return this._cd.control ? this._cd.control.pristine : false; }
/**
 * @return {?}
 */
get ngClassDirty(): boolean { return this._cd.control ? this._cd.control.dirty : false; }
/**
 * @return {?}
 */
get ngClassValid(): boolean { return this._cd.control ? this._cd.control.valid : false; }
/**
 * @return {?}
 */
get ngClassInvalid(): boolean { return this._cd.control ? this._cd.control.invalid : false; }
/**
 * @return {?}
 */
get ngClassPending(): boolean { return this._cd.control ? this._cd.control.pending : false; }
}

function AbstractControlStatus_tsickle_Closure_declarations() {
/** @type {?} */
AbstractControlStatus.prototype._cd;
}


export const /** @type {?} */ ngControlStatusHost = {
  '[class.ng-untouched]': 'ngClassUntouched',
  '[class.ng-touched]': 'ngClassTouched',
  '[class.ng-pristine]': 'ngClassPristine',
  '[class.ng-dirty]': 'ngClassDirty',
  '[class.ng-valid]': 'ngClassValid',
  '[class.ng-invalid]': 'ngClassInvalid',
  '[class.ng-pending]': 'ngClassPending',
};
/**
 * Directive automatically applied to Angular form controls that sets CSS classes
 * based on control status. The following classes are applied as the properties
 * become true:
 * 
 * * ng-valid
 * * ng-invalid
 * * ng-pending
 * * ng-pristine
 * * ng-dirty
 * * ng-untouched
 * * ng-touched
 * 
 * \@stable
 */
export class NgControlStatus extends AbstractControlStatus {
/**
 * @param {?} cd
 */
constructor( cd: NgControl) { super(cd); }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: '[formControlName],[ngModel],[formControl]', host: ngControlStatusHost}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgControl, decorators: [{ type: Self }, ]},
];
}

function NgControlStatus_tsickle_Closure_declarations() {
/** @type {?} */
NgControlStatus.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgControlStatus.ctorParameters;
}

/**
 * Directive automatically applied to Angular form groups that sets CSS classes
 * based on control status (valid/invalid/dirty/etc).
 * 
 * \@stable
 */
export class NgControlStatusGroup extends AbstractControlStatus {
/**
 * @param {?} cd
 */
constructor( cd: ControlContainer) { super(cd); }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector:
      '[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]',
  host: ngControlStatusHost
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ControlContainer, decorators: [{ type: Self }, ]},
];
}

function NgControlStatusGroup_tsickle_Closure_declarations() {
/** @type {?} */
NgControlStatusGroup.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgControlStatusGroup.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../../packages/forms/src/directives/ng_control_status.ts